export const pickSupportedMimeType = (
  candidates: readonly string[],
  isTypeSupported: (mimeType: string) => boolean,
  fallback: string,
): string => candidates.find(isTypeSupported) ?? fallback;
